import { css } from '@emotion/react';
import { White, Red } from '@constants/color';

export const title = css({
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '62.4px',
  color: White.White10,
  padding: '45px 0 160px'
});

export const content = css({
  display: 'flex',
  flexDirection: 'row',
  gap: 120,
  margin: '0 0 0 150px'
});

export const instruction = css({
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '43.2px',
  paddingBottom: 80
});

export const commonInformation = css({
  fontWeight: 500,
  fontSize: '40px',
  color: White.White10,
  margin: '20px 0 0 0',
  lineHeight: '52px'
});
export const descriptionInformation = css({
  fontWeight: 500,
  fontSize: '32px',
  margin: '24px 0 24px 0',
  color: White.White10Alpha70
});

export const qrCode = css({
  width: 440,
  height: 440,
  border: '10px solid #fff'
});

export const qrTitle = css({
  fontWeight: 700,
  fontSize: 80,
  lineHeight: '38.19px',
  color: White.White10,
  padding: '48px 0 24px'
});

export const noPaymentText = css({
  fontWeight: 500,
  fontSize: '32px',
  margin: '24px 0 0 0',
  color: Red.Red50
});

export const button = css({
  width: 400,
  margin: '80px 0 0 0'
});
